import { randomNumber } from '../../../../utilities'
import { HospitalNotifyConstants } from './hospitalNotify.constants'
import { IHospitalNotifyAction, IHospitalNotifyState } from './hospitalNotify.types'

export const initialHospitalNotifyState: IHospitalNotifyState = {
  method: null,
  alertType: null,
  alertTypePNNV: null,
  potentialRegistry: [],
  assessedBy: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Hosp. Notify',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  nemsisCode: null,
}

export function hospitalNotifyReducer(
  state: IHospitalNotifyState = initialHospitalNotifyState,
  action: IHospitalNotifyAction
): IHospitalNotifyState {
  switch (action.type) {
    case HospitalNotifyConstants.SET_METHOD:
      return { ...state, method: action.method }
    case HospitalNotifyConstants.SET_ALERT_TYPE:
      return { ...state, alertType: action.alertType }
    case HospitalNotifyConstants.SET_POTENTIAL_REGISTRY:
      return { ...state, potentialRegistry: action.potentialRegistry }
    case HospitalNotifyConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case HospitalNotifyConstants.SET_DATE:
      return { ...state, date: action.date }
    case HospitalNotifyConstants.SET_TIME:
      return { ...state, time: action.time }
    case HospitalNotifyConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case HospitalNotifyConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case HospitalNotifyConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case HospitalNotifyConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case HospitalNotifyConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case HospitalNotifyConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case HospitalNotifyConstants.SET_STATE:
      return { ...action.hospitalNotifyState, updateInputRows: true }
    case HospitalNotifyConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case HospitalNotifyConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case HospitalNotifyConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case HospitalNotifyConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case HospitalNotifyConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case HospitalNotifyConstants.RESET_STATE:
      return {
        method: null,
        alertType: null,
        alertTypePNNV: null,
        potentialRegistry: [],
        assessedBy: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Hosp. Notify',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
